import BaseModel from './BaseModel';
import Resource from './Resource';
import * as AT from '../../components/container/attributes';

export default class ResourcePackaging extends BaseModel {
  constructor({id, resource, factor}) {
    super(id, undefined, undefined);
    this.resource = resource ? new Resource(resource) : null;
    this.factor = factor;
  }

  static get fkName() {
    return null;
  }
  static get apiRoute() {
    return 'resource_packaging';
  }
  static get listPageRoute() {
    return undefined;
  }
  static get detailPageRoute() {
    return undefined;
  }
  static get createInitColumns() {
    return {};
  }
  get fkName() {
    return ResourcePackaging.fkName;
  }
  get apiRoute() {
    return ResourcePackaging.apiRoute;
  }
  get detailPageRoute() {
    return ResourcePackaging.detailPageRoute;
  }
  get listPageRoute() {
    return ResourcePackaging.listPageRoute;
  }
  get createInitColumns() {
    return ResourcePackaging.createInitColumns;
  }

  static get entityListDisplayAttrs() {
    return this.getAttributes(['unit', 'factor']);
  }

  static get allAttributes() {
    return [
      new AT.FkUnitAttribute({
        name: 'unit',
        joinPath: ['unit!fk_resource_packaging_unit_id_unit'],
        tableProperties: {
          header: 'hit-base.common.unit',
        },
      }),
      new AT.FkResourceAttribute({
        name: 'resource',
        joinPath: ['resource!fk_resource_packaging_resource_id_resource'],
        fkToUpdate: 'data_resource_id',
        tableProperties: {
          header: 'hit-base.common.resource',
        },
      }),
      new AT.DecimalAttribute({
        name: 'factor',
        decimalPrecision: 4,
        creationValue: 1,
        tableProperties: {
          header: 'hit-app.common.factor',
          maxWidth: '1fr',
        },
      }),
    ];
  }
}
